var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElecsumSpinnerGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492 492",
    style: {
      enableBackground: "new 0 0 492 492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.9883,
    y1: 268.373,
    x2: 522.5085,
    y2: 117.8858,
    gradientTransform: "matrix(1 0 0 -1 0 494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5E61E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.3,0c-1.4,0-2.8,0-4.2,0C148.7,1.6,69.6,53.4,28.8,129.1c-0.9,1.6-0.6,3.7,0.7,5l326.3,327.7 c0.8,0.8,1.9,1.2,3,1.2c0.7,0,1.3-0.2,1.9-0.5c75.4-41,127-120.5,128.5-212.2C491.5,113.3,380.1,0,244.3,0L244.3,0z M0.2,237.5 v143.1C0.2,442.1,49.9,492,111.1,492h133.2c3.1,0,6.2-0.1,9.3-0.2c4.3-0.2,6.3-5.4,3.3-8.4L8.6,234c-1-1-2.2-1.4-3.4-1.4 C2.6,232.6,0.2,234.5,0.2,237.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElecsumSpinnerGradient);
export default __webpack_public_path__ + "static/media/ElecsumSpinnerGradient.aed1dddb.svg";
export { ForwardRef as ReactComponent };